import type { DrillDownMetricType } from "@/lib/metrics/deal-queries";

export interface DrillDownRequest {
  metric: DrillDownMetricType;
  section: "main" | "nr" | "aff" | "source" | "campus" | "commission" | "dr-aff" | "byx";
  month?: string;
  quarter?: string;
  campus?: string;
  sources?: string[];
  affiliateExclusions?: string[];
  drOwnerId?: string;
  affiliateNames?: string[];
  label: string;
  companyWide?: boolean;
}

export function DrillableValue({
  children,
  onClick,
  disabled,
}: {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}) {
  if (disabled || !onClick) return <>{children}</>;
  return (
    <button
      type="button"
      onClick={onClick}
      className="cursor-pointer hover:underline underline-offset-2 decoration-accent/50 hover:decoration-accent transition-colors"
    >
      {children}
    </button>
  );
}
